"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UrlAssignerPageActions;
(function (UrlAssignerPageActions) {
    UrlAssignerPageActions["DataLoaded"] = "DataLoaded";
})(UrlAssignerPageActions || (UrlAssignerPageActions = {}));
exports.default = UrlAssignerPageActions;
